import axios from 'axios'
// 我的教学课程列表
export function getMyCourseList(params) {
    return axios({
        url: '/course/teachCourse/getTeachList',
        method: 'get',
        params
    })
}
//获取专业树
export function getMajorTree(params) {
    return axios({
        url: '/infrastructure/basicMajorCategory/getMajorTree',
        method: 'get',
        params
    })
}
// 专业大类
export function getMajorKind(params) {
    return axios({
        url: '/infrastructure/basicMajorCategory/allList',
        method: 'get',
        params
    })
}
// 专业大类获取子类
export function getProfessionalSubclass(params) {
    return axios({
        url: '/infrastructure/basicMajorSubclass/queryByCategoryId',
        method: 'get',
        params
    })
}
// 专业子类获取专业
export function getMajor(params) {
    return axios({
        url: '/infrastructure/basicMajor/queryBySubclassId',
        method: 'get',
        params
    })
}
// 获取开课信息
export function getCourseInfo(params) {
    return axios({
        url: '/course/teachCourseConstruction/getCourseView',
        method: 'get',
        params
    })
}
// 课程中心
export function getCourseCenterInfo(params) {
    return axios({
        url: '/home/courseInfo',
        method: 'get',
        params
    })
}
// 课程添加
export function addCourse(data) {
    return axios({
        url: '/course/teachCourse/add',
        method: 'post',
        data
    })
}
// 课程删除
export function deleteCourse(params) {
    return axios({
        url: '/course/teachCourseConstruction/delete',
        method: 'delete',
        params
    })
}
// 课程修改
export function editCourse(data) {
    return axios({
        url: '/course/teachCourse/edit',
        method: 'put',
        data
    })
}

// 新建开课
export function addNewCourse(params) {
    return axios({
        url: '/course/teachCourseConstruction/checkBegins',
        method: 'get',
        params
    })
}
// 是否同意合作协议
export function isAgreeAgreement(params) {
    return axios({
        url: '/course/teachAgreementRecord/getState',
        method: 'get',
        params
    })
}
// 同意合作协议
export function AgreeAgreement(data) {
    return axios({
        url: '/course/teachAgreementRecord/add',
        method: 'post',
        data
    })
}
// 开课信息添加
// export function addCourseInfo(data) {
//     return axios({
//         url: '/course/teachCourseConstruction/add',
//         method: 'post',
//         data
//     })
// }
// 开课学习设置
export function addStudySet(data) {
    return axios({
        url: '/course/teachCourseConstruction/addStudy',
        method: 'post',
        data
    })
}
// 证书设置添加
export function addCertificate(data) {
    return axios({
        url: '/course/teachCourseConstruction/addCertificate',
        method: 'post',
        data
    })
}
// 补充信息添加
export function addReplenish(data) {
    return axios({
        url: '/course/teachCourseConstruction/add',
        method: 'post',
        data
    })
}
// 获取开课设置内容
export function getCourseContent(params) {
    return axios({
        url: '/course/teachCourseConstruction/getCourseSet',
        method: 'get',
        params
    })
}
//获取教学团队
export function getTeachingTeam(params) {
    return axios({
        url: '/course/teachCourseGroup/getListByCourse',
        method: 'get',
        params
    })
}
//教学团队获取用户列表
export function getUserPageList(params) {
    return axios({
        url: '/sys/user/getUserPageList',
        method: 'get',
        params
    })
}
//获取系部、专业
export function getOrganSdeptMajor(params) {
    return axios({
        url: '/school/majorInfo/getOrganSdeptMajor',
        method: 'get',
        params
    })
}
// 通知公告添加
export function addCourseNotice(data) {
    return axios({
        url: '/course/teachCourseNotice/add',
        method: 'post',
        data
    })
}
//教学团队添加
export function addTeachCourseGroup(data) {
    return axios({
        url: '/course/teachCourseGroup/add',
        method: 'post',
        data
    })
}
//教学团队删除
export function deleteTeachCourseGroup(params) {
    return axios({
        url: '/course/teachCourseGroup/deleteBatch',
        method: 'delete',
        params
    })
}
// 获取测验题型
export function testQuestionTypes(params) {
    return axios({
        url: '/sys/dictItem/getItemList',
        method: 'get',
        params
    })
}
// 添加题目
export function addTestQuestions(data) {
    return axios({
        url: '/testing/teachTest/add',
        method: 'post',
        data
    })
}
// 获取试题库试题
export function testList(params) {
    return axios({
        url: '/testing/teachTest/list',
        method: 'get',
        params
    })
}
// 题目分配目录
export function topicAllocation(data) {
    return axios({
        url: '/exam/examQuestionInfo/contactQ',
        method: 'post',
        data
    })
}
// 获取考试随机试题
export function testRandomQuestions(type,id) {
    return axios({
        url: `/exam/examQuestionInfo/selectQuestionNum/${type}/${id}`,
        method: 'get',
    })
}
// 完成选题
export function accomplishTopic(data,questionFlag,constructionId) {
    return axios({
        url: `/exam/examQuestionInfo/randomSave/${questionFlag}/${constructionId}`,
        method: 'post',
        data
    })
}
// 题目基本信息-添加
export function addTopic(data) {
    return axios({
        url: '/exam/examQuestionInfo/add',
        method: 'post',
        data
    })
}
// 题目基本信息-编辑
export function editTopic(data) {
    return axios({
        url: '/exam/examQuestionInfo/edit',
        method: 'put',
        data
    })
}
// 通知公告列表
export function getCourseNotice(params) {
    return axios({
        url: '/course/teachCourseNotice/list',
        method: 'get',
        params
    })
}
// 通知公告编辑+发布
export function editCourseNotice(data) {
    return axios({
        url: '/course/teachCourseNotice/edit',
        method: 'put',
        data
    })
}
// 通知公告删除
export function deleteCourseNotice(params) {
    return axios({
        url: '/course/teachCourseNotice/delete',
        method: 'delete',
        params
    })
}
// 作业-分页列表查询
export function getHomeworkList(params) {
    return axios({
        url: '/testing/teachCourseHomework/list',
        method: 'get',
        params
    })
}
// 测验-分页列表查询
export function getTestList(params) {
    return axios({
        url: '/testing/teachCourseTest/list',
        method: 'get',
        params
    })
}
// 作业-通过id删除
export function deleteHomework(params) {
    return axios({
        url: '/testing/teachCourseHomework/delete',
        method: 'delete',
        params
    })
}
// 测验-通过id删除
export function deleteTest(params) {
    return axios({
        url: '/testing/teachCourseTest/delete',
        method: 'delete',
        params
    })
}
// 开课内容校验
export function getCourseChecking(params) {
    return axios({
        url: '/course/teachCourseConstruction/courseChecking',
        method: 'get',
        params
    })
}
// 获取考试列表
export function getExaminationList(params) {
    return axios({
        url: '/exam/examInfo/allList',
        method: 'get',
        params
    })
}
// 获取已批学生列表
export function getIsGroupStudent(params) {
    return axios({
        url: '/exam/examInfo/judgeList',
        method: 'get',
        params
    })
}
// 获取未批学生列表
export function getNoBatchStudent(params) {
    return axios({
        url: '/exam/examInfo/unjudgeList',
        method: 'get',
        params
    })
}
// 获取考试分析详情
export function examinationAnalysis(id) {
    return axios({
        url: `/exam/examInfo/examAnalysis/${id}`,
        method: 'get',
    })
}
// 考试预览
export function testPreview(id,params) {
    return axios({
        url: `/exam/examInfo/testPreview/${id}`,
        method: 'get',
        params
    })
}
// 学生答完考试预览
export function stuExaminationGrade(examId,studentId) {
    return axios({
        url: `/exam/examInfo/testStuPreview/${examId}/${studentId}`,
        method: 'get',
    })
}
//系统审核管理-提交审核
export function submitAudit(data) {
    return axios({
        url: '/systeachaudit/sysTeachAudit/submitAudit',
        method: 'post',
        data
    })
}
//生成审核错误txt
export function errorContent(data) {
    return axios({
        url: '/course/teachCourseConstruction/importErrorContent',
        method: 'post',
        data
    })
}
// 获取自定义菜单列表
export function getcustomMenu(params) {
    return axios({
        url: '/teachcoursecustomcontent/teachCourseCustomContent/list',
        method: 'get',
        params
    })
}
// 获取自定义菜单列表
export function getcustomVisualMenu(params) {
    return axios({
        url: '/teachcoursecustomcontent/teachCourseCustomContent/visual/list',
        method: 'get',
        params
    })
}
// 学校管理-教师列表获取开课菜单列表
export function getCourseMenu(params) {
    return axios({
        url: '/course/teachCourseMenu/list',
        method: 'get',
        params
    })
}
// 学校管理-教师列表获取开课菜单列表
export function getCourseVisualMenu(params) {
    return axios({
        url: '/course/teachCourseMenu/visual/list',
        method: 'get',
        params
    })
}
//课程自定义内容 -添加
export function addCustomContent(data) {
    return axios({
        url: '/teachcoursecustomcontent/teachCourseCustomContent/add',
        method: 'post',
        data
    })
}
// 课程自定义内容 -编辑
export function editCustomContent(data) {
    return axios({
        url: '/teachcoursecustomcontent/teachCourseCustomContent/edit',
        method: 'put',
        data
    })
}
// 课程自定义内容 -通过id删除
export function delCustomContent(params) {
    return axios({
        url: '/teachcoursecustomcontent/teachCourseCustomContent/delete',
        method: 'delete',
        params
    })
}
// 开课-通过课程id统计
export function queryByCourseId(params) {
    return axios({
        url: '/course/statistics/visual/queryByCourseId',
        method: 'get',
        params
    })
}
// 开课-编辑免登陆连接
export function updateAddress(data) {
    return axios({
        url: '/course/teachCourseConstruction/UpdateAddress',
        method: 'put',
        data
    })
}
// 课程自定义内容 -编辑
export function editTeachCourseGroup(data) {
    return axios({
        url: '/course/teachCourseGroup/edit',
        method: 'put',
        data
    })
}